import { createFileRoute } from '@tanstack/react-router';
import { Breadcrumbs } from '@components/navigation/Breadcrumb.tsx';
import SupplierLayout from '@components/layout/supplier/SupplierLayout.tsx';
import SupplierProductList from '@features/supplier/catalog/SupplierProductList.tsx';
import { z } from 'zod';
import { useSupplierProductStore } from '@features/supplier/catalog/supplierProductStore.ts';
import { useTranslation } from 'react-i18next';

const supplierCatalogSearchSchema = z.object({
  query: z.string().optional(),
  page: z.coerce.number().optional().default(1),
});

export type SupplierCatalogSearch = z.infer<typeof supplierCatalogSearchSchema>;

export const Route = createFileRoute('/s/$orgId/$portalId/catalog')({
  validateSearch: search => supplierCatalogSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { query, page } = ctx.search;
    useSupplierProductStore.getState().fetchProducts({
      query,
      page: page || 1,
    });
  },
});

function RouteComponent() {
  const { t } = useTranslation('client');
  return (
    <SupplierLayout>
      <div className="mb-8">
        <Breadcrumbs items={[{ label: t('supplierCatalog.breadcrumb'), href: undefined }]} />
        <div className="flex items-center justify-between mb-2 mt-4">
          <h1 className="text-3xl font-bold text-main">{t('supplierCatalog.pageTitle')}</h1>
        </div>
        <p className="text-light">{t('supplierCatalog.pageDescription')}</p>
      </div>

      <SupplierProductList />
    </SupplierLayout>
  );
}
